export default "__VITE_ASSET__CzfX_mJL__"